import { toast } from "react-toastify";
import { Request } from "../../hooks/Request";
import { H2, H3 } from "../../components/Text";
import { Button } from "../../components/Buttons";
import Circle from "../../components/Animation/Circle";
import { useModal } from "../../contexts/ModalContext";
import { useDialog } from "../../contexts/DialogContext";
import FormDefault from "../../components/Forms/FormDefault";
import TableGeneral from "../../components/ExcelPages/TableGeneral";
import { requestAuth } from "../../components/services/RequestService";
import { numberWithDecimals, validateArray } from "../../utils/validate";

import { Page, Document, PDFViewer, StyleSheet } from "@react-pdf/renderer";
import Text from "../../components/GeneratePdf/Text";
import View from "../../components/GeneratePdf/View";
import { DialogConfirmation } from "../../components/Modal";
import { viewLinkExcel } from "../../utils/constGenerate";
import { MyDocClearanceForm } from "../ManegeProcedure/MyDocClearanceForm";
import { FormDataItems } from "./FormDataItems";
import { formattedValue } from "../../utils/utils";
import config from "../../config.json";

const styles = StyleSheet.create({
  page: {
    padding: "50px 40px",
    fontSize: 8.5,
  },
  seccion: {
    marginBottom: 3,
  },
  title: {
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#9e9e9e",
    textAlign: "center",
    fontWeight: "bold",
    padding: 4,
    fontSize: 10,
  },
  text: {
    textAlign: "left",
    paddingLeft: 2,
  },
  text1: {
    fontWeight: "bold",
    textAlign: "right",
  },
  contenedorPadre: {
    flexDirection: "row",
    justifyContent: "space-between",
    borderBottom: 1,
    borderTop: 1,
    borderRight: 1,
    borderLeft: 1,
    borderStyle: "solid",
    borderColor: "#9e9e9e",
  },
  contenedor: {
    textAlign: "center",
    justifyContent: "center",
    width: "100%",
    height: 20,
    borderLeft: 1,
    borderStyle: "solid",
    borderColor: "#9e9e9e",
  },
  contendor1: {
    flexDirection: "column",
    flex: 3,
    borderStyle: "solid",
    borderColor: "#9e9e9e",
    paddingHorizontal: 8,
    paddingVertical: 2,
    gap: 5,
  },
  contendor2: {
    flexDirection: "column",
    flex: 1,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#9e9e9e",
    paddingHorizontal: 8,
    paddingVertical: 2,
    gap: 5,
  },
  contenedorTabla: {
    flexDirection: "row",
    justifyContent: "space-between",
    borderStyle: "solid",
    borderColor: "#9e9e9e",
  },
  footer: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    padding: 40,
  },
});

const listDataValues = [
  "internCode",
  "codigoDeInterno",
  "nroCotizacion",
  "modalidadDeDespacho",
  "descripciónDeLaMercancía",
  "partidaArancelaria",
  "valoresNominales",
  "asignarRégimenDeImportación",
  //
  "fechaDeCotización",
  "tipoDeDespacho",
  "a4AduanaDeDespacho",
  "proveedor",
  "nroFacturaComercial",
  "piNro",
  "nroBl",
  "tipoDeCambioProforma",
  "nroDeContenedor",
];
const CloneItems = (props) => {
  const { procedureId, importExcel, handleDelete } = props;
  const { openDialog, dialogClose } = useDialog();
  const { openModal, onClose } = useModal();
  const { data, loading, call } = Request({
    urlApi: `/ItemDataProcedure/procedure/${procedureId}/list`,
  });
  const { data: dataProcedure, loading: loadingProcedure } = Request({
    urlApi: `/Procedure/${procedureId}/dataValues?${listDataValues
      .map((field) => `fieldnames=${field}`)
      .join("&")}`,
  });

  // function handleClone() {
  //   openDialog(
  //     <FormClone
  //       reload={call}
  //       onClose={dialogClose}
  //       procedureId={procedureId}
  //     />
  //   );
  // }

  function FormGenerateSpreadsheet() {
    openModal(
      <FormDataItems
        items={data}
        dataProcedure={{
          ...dataProcedure,
          id: dataProcedure.procedureId,
        }}
        openDialog={openDialog}
        dialogClose={dialogClose}
      />,
    );
  }

  function handleDownloadExcel() {
    openDialog(
      <DialogConfirmation
        children={<H3>¿Estas seguro que quieres generar el excel?</H3>}
        onClose={dialogClose}
        method="get"
        url={`/ItemDataProcedure/export/${procedureId}`}
        texBtn="Generar"
        handleSuccess={viewLinkExcel}
        handlePreView={(data) => {
          return data.url;
        }}
      />,
    );
  }

  if (!loading || !loadingProcedure) {
    return <Circle />;
  }
  return (
    <div>
      <div className="flex justify-between items-center mb-2">
        <H2>Clonar items</H2>
        <div className="flex gap-2 items-center">
          {validateArray(data) && (
            <Button
              position="left"
              className="text-base px-1.5 py-1"
              content="Generar planilla de gastos"
              onClick={FormGenerateSpreadsheet}
            >
              Generar planilla <i className="fas fa-print"></i>
            </Button>
          )}
          {/* <Button
            position="left"
            className="text-base px-1.5 py-1"
            content="Clonar items"
            onClick={handleClone}
          >
            Clonar items <i className="fas fa-copy"></i>
          </Button> */}
          <Button
            position="left"
            className="text-base px-1.5 py-1"
            content="Extraer datos de un excel"
            onClick={() => importExcel(call, `ItemDataProcedure/import`)}
          >
            Extraer de un excel <i className="fas fa-clone"></i>
          </Button>
          <Button
            position="left"
            className="text-base px-1.5 py-1 bg-gray-500 text-white"
            content="Descargar en excel"
            onClick={handleDownloadExcel}
          >
            Descargar en excel
          </Button>
        </div>
      </div>
      <TableGeneral
        addBtn="Adicionar item"
        editBtn="Editar item"
        restHeight={200}
        call={call}
        handleReload={call}
        header={[
          { name: "item", label: "Item", hidden: true },
          { name: "referencia", label: "Referencia" },
          { name: "interno", label: "Interno" },
          { name: "gestion", label: "Gestión" },
          { name: "dim", label: "DIM" }, // nuevo
          { name: "nombreMercaderia", label: "Nombre mercaderia" },
          { name: "modelo", label: "Modelo" },
          { name: "marca", label: "Marca" },
          { name: "chasis", label: "Chasis" },

          { name: "valorFOB", label: "Valor FOB" },
          { name: "flete1", label: "Flete 1" },
          { name: "flete2", label: "Flete 2" },
          { name: "seguro", label: "Seguro" },

          { name: "gravamen", label: "GA" },
          { name: "iva", label: "IVA" },
          { name: "ice", label: "ICE" },
          // { name: "facturaComercial", label: "Factura comercial" },
          // { name: "bl", label: "BL" },
          // { name: "ordenCompra", label: "Orden de compra" },
          // { name: "cantidadItem", label: "Cantidad item" },
          // { name: "bultos", label: "Bultos" },
          // { name: "pesoBruto", label: "Peso bruto" },
          // { name: "pesoNeto", label: "Peso neto" },
          // { name: "gastosPuerto", label: "Gastos puerto" },
          // { name: "otrosGastos", label: "Otros gastos" },
          // { name: "formularioSidunea", label: "Formulario Sidunea" },
          // {
          //   name: "alboAlmaceneraBoliviana",
          //   label: "Albo Almacenera Boliviana",
          // },
          // { name: "dabAlmacenaje", label: "DAB Almacenaje" },
          // {
          //   name: "gastosOperacionesAduanerasHonorarios",
          //   label: "Gastos operaciones aduaneras honorarios",
          // },
          // { name: "gastosDespacho", label: "Gastos despacho" },
          // { name: "recojoDocumento", label: "Recojo documento" },
          // { name: "soat", label: "SOAT" },
          // {
          //   name: "servicioOperacionesAduaneras",
          //   label: "Servicio operaciones aduaneras",
          // },
          // {
          //   name: "servicioGastosDespacho",
          //   label: "Servicio gastos despacho",
          // },
          // { name: "servicioLogistica", label: "Servicio logística" },
          // {
          //   name: "servicioGestionArchivo",
          //   label: "Servicio gestión archivo",
          // },

          // {
          //   name: "action",
          //   type: "action",
          //   label: "",
          //   hidden: true,
          //   actions: [
          //     // {
          //     //   label: 'Clonar',
          //     //   icon: 'fas fa-copy',
          //     //   action: (item, reload) =>
          //     //     handleClone(item, reload, procedureId),
          //     //   color: 'text-[#1d4ed8]',
          //     //   bgColor: 'bg-[#1d4fd842]',
          //     // },
          //     {
          //       label: "Eliminar",
          //       icon: "fas fa-trash",
          //       action: (item, reload) =>
          //         handleDelete(
          //           item,
          //           reload,
          //           "el item",
          //           `/procedureSheet/item/${item.id}`
          //         ),
          //       color: "text-red-500",
          //       bgColor: "bg-red-300",
          //     },
          //   ],
          // },
        ]}
        data={data}
        // urlPost={`/Item/procedure/${procedureId}/vehicle`}
        // urlPut="/Item/vehicle/"
      />
    </div>
  );
};

const listData = [
  "internCode",
  "codigoDeInterno",
  "nroCotizacion",
  "modalidadDeDespacho",
  "descripciónDeLaMercancía",
  "partidaArancelaria",
  "valoresNominales",
  "asignarRégimenDeImportación",
  "a2FechaDeAceptación",
  //
  "fechaDeCotización",
  "tipoDeDespacho",
  "proveedor",
  "piNro",
  "nroBl",
  "tipoDeCambioProforma",
  "nroDeContenedor",

  "fechaPagoDeLaDim",
  "fechaDePlanilla",
  "canal(Rojo,AmarilloOVerde)",
  "a4AduanaDeDespacho",
  "nroFacturaComercial",
  "erogaciones",
  "honorariosProfesionales",

  "a-TributosYOtrosConceptosAduaneros",
  "b-OtrosGastosDeImportacion/Exportacion",
  "c-GastosDeOperaciones",
];
export const FormGenerate = (props) => {
  const { openDialog, dataProcedure, items } = props;
  const { data, loading } = Request({
    urlApi: `/Procedure/${dataProcedure.procedureId}/dataValues?${listData
      .map((field) => `fieldnames=${field}`)
      .join("&")}`,
  });

  const { data: dataStateAccount, isLoading: isLoadingStateAccount } = Request({
    urlApi: `${config.requestURLConta}/api/StateAccount/${dataProcedure.procedureId}`,
  });

  if (!loading && !isLoadingStateAccount) {
    return <Circle />;
  }

  return (
    <>
      <FormDefault
        tittle="Formulario para generar planilla de gastos"
        fields={[
          {
            label: "Desde",
            name: "From",
            placeholder: "Desde",
          },
          {
            label: "Hasta",
            name: "To",
            placeholder: "Hasta",
          },
        ]}
        initialValues={{
          From: "1",
          To: "1",
        }}
        validationSchema={null}
        onSubmit={(values) => {
          openDialog(
            <RenderGenerateSpreadsheet
              limit={values}
              items={items}
              dataProcedure={data}
              dataStateAccount={dataStateAccount}
            />,
          );
        }}
        buttonName="Generar"
      />
      <br />
    </>
  );
};

export const RenderGenerateSpreadsheet = (props) => {
  const { limit, items, dataProcedure, dataStateAccount } = props;

  const MyDoc = (
    <Document>
      {items
        ? items.map((item, index) => {
            if (index + 1 >= limit.From && index + 1 <= limit.To) {
              return (
                <Page key={index} size="A4" style={styles.page}>
                  <Spreadsheet
                    item={{
                      ...item,
                      nro: index + 1,
                      totalItems: items.length || 0,
                    }}
                    dataProcedure={dataProcedure}
                    dataStateAccount={dataStateAccount}
                  />
                </Page>
              );
            } else {
              return null;
            }
          })
        : ""}
    </Document>
  );

  return (
    <div>
      <PDFViewer
        style={{
          width: 900,
          height: window.innerHeight - 100,
        }}
        children={MyDoc}
      />
    </div>
  );
};

const transformData = (item, data, dataStateAccount) => {
  console.log("🚀 ~ transformData ~ item:", item);
  const totalAnticipos = dataStateAccount?.items
    ? dataStateAccount.items
        .filter((item) => item.type === 2)
        .reduce((sum, item) => sum + item.asset, 0)
    : 0;

  const invoice = dataStateAccount?.items
    ? dataStateAccount.items.find((item) => item.type === 8)
    : 0;

  const valorFOB = item.valorFOB || 0;
  const flete = (item.flete1 || 0) + (item.flete2 || 0);
  const seguro = item.seguro || 0;
  const valorCIF = valorFOB + flete + seguro;

  const totalErogaciones =
    data?.["b-OtrosGastosDeImportacion/ExportacionSubDatas"] &&
    validateArray(data?.["b-OtrosGastosDeImportacion/ExportacionSubDatas"])
      ? data["b-OtrosGastosDeImportacion/ExportacionSubDatas"].reduce(
          (sum, e) => {
            let importe = 0;

            if (e.observation) {
              try {
                const rangos = JSON.parse(e.observation);
                const itemNumero = item.nro;

                for (const rango of rangos) {
                  const from = Number(rango.from);
                  const to = Number(rango.to);
                  const amount = Number(rango.amount);

                  if (itemNumero >= from && itemNumero <= to) {
                    importe = amount;
                    break;
                  }
                }
              } catch (error) {
                // console.error("Error parsing observation JSON:", error);
                // importe = Number(e.description2) || 0;
              }
            } else {
              // importe = Number(e.description2) || 0;
            }
            return sum + Number(importe);
          },
          0,
        )
      : 0;

  const totalTributos =
    (item.gravamen || 0) + (item.iva || 0) + (item.ice || 0) + 100;
  const totalHonorarios =
    data?.["c-GastosDeOperacionesSubDatas"] &&
    validateArray(data["c-GastosDeOperacionesSubDatas"])
      ? data["c-GastosDeOperacionesSubDatas"].reduce((sum, e) => {
          let importe = 0;

          if (e.observation) {
            try {
              const rangos = JSON.parse(e.observation);
              const itemNumero = item.nro;

              for (const rango of rangos) {
                const from = Number(rango.from);
                const to = Number(rango.to);
                const amount = Number(rango.amount);

                if (itemNumero >= from && itemNumero <= to) {
                  importe = amount;
                  break;
                }
              }
            } catch (error) {
              // console.error("Error parsing observation JSON:", error);
              // importe = Number(e.description2) || 0;
            }
          } else {
            // importe = Number(e.description2) || 0;
          }
          return sum + Number(importe);
        }, 0)
      : 0;

  const totalGeneral = totalTributos + totalErogaciones + totalHonorarios;

  return {
    numero: item.referencia || item.reference || "",
    fecha: {
      dim: data.a2FechaDeAceptación || "",
      planilla: invoice ? invoice.date : "",
      // dim: data.procFechaDeInicio
      //   ? new Date(data.procFechaDeInicio).toLocaleDateString()
      //   : "",
      // planilla: new Date().toLocaleDateString(),
    },
    cliente: {
      nombre: data.company.razonSocial || "",
      direccion: data.company.direccion || "",
      email: data.company.email || "",
      hojaTrabajo: formattedValue(data.procNumberString) || "",
    },
    declaracion: {
      nroRegistro: item.dim || "-",
      regimenAduanero: data.asignarRégimenDeImportación || "-",
      aduanaDespacho: data.a4AduanaDeDespacho || "-",
      valoCif: valorCIF,
      canal: data["canal(Rojo,AmarilloOVerde)"] || "-",
    },
    descripcionMercadria: `${item.nombreMercaderia || item.productName || "-"} | ${
      item.modelo || item.model || "-"
    } | MARCA: ${item.marca || item.brand || "-"} | CHASIS: ${
      item.chasis || item.chasisNumber || "-"
    } | FACTURA COMERCIAL: ${data.nroFacturaComercial || "-"} | BL: ${
      data.nroBl || "-"
    }`,
    tributos: [
      { desc: "GA-GRAVAMEN ARANCELARIO", importe: item.gravamen || 0 },
      { desc: "IVA- IMPUESTO AL VALOR AGRAGADO", importe: item.iva || 0 },
      { desc: "ICE- IMPUESTO AL CONSUMO ESPECIFICO", importe: item.ice || 0 },
      { desc: "USO FORMULARIO DIGITAL", importe: 100 },
    ].filter((t) => t.importe > 0),
    erogaciones:
      data?.["b-OtrosGastosDeImportacion/ExportacionSubDatas"] &&
      validateArray(data?.["b-OtrosGastosDeImportacion/ExportacionSubDatas"])
        ? data?.["b-OtrosGastosDeImportacion/ExportacionSubDatas"]
            .map((e) => {
              let importe = 0;

              if (e.observation) {
                try {
                  const rangos = JSON.parse(e.observation);
                  const itemNumero = item.nro;

                  for (const rango of rangos) {
                    const from = Number(rango.from);
                    const to = Number(rango.to);
                    const amount = Number(rango.amount);

                    if (itemNumero >= from && itemNumero <= to) {
                      importe = amount;
                      break;
                    }
                  }
                } catch (error) {
                  // console.error("Error parsing observation JSON:", error);
                  // importe = Number(e.description2) || 0;
                }
              } else {
                // importe = Number(e.description2) || 0;
              }
              return {
                desc: e.label,
                importe: importe,
              };
            })
            .filter((h) => h.importe > 0)
        : [],
    honorarios:
      data?.["c-GastosDeOperacionesSubDatas"] &&
      validateArray(data["c-GastosDeOperacionesSubDatas"])
        ? data["c-GastosDeOperacionesSubDatas"]
            .map((e) => {
              let importe = 0;

              if (e.observation) {
                try {
                  const rangos = JSON.parse(e.observation);
                  const itemNumero = item.nro;

                  for (const rango of rangos) {
                    const from = Number(rango.from);
                    const to = Number(rango.to);
                    const amount = Number(rango.amount);

                    if (itemNumero >= from && itemNumero <= to) {
                      importe = amount;
                      break;
                    }
                  }
                } catch (error) {
                  // console.error("Error parsing observation JSON:", error);
                  // importe = Number(e.description2) || 0;
                }
              } else {
                // importe = Number(e.description2) || 0;
              }
              return {
                desc: e.label,
                importe: importe,
              };
            })
            .filter((h) => h.importe > 0)
        : [],
    totalGeneral: totalGeneral,
    tributosImportador: totalTributos + totalErogaciones,
    anticipoImportador: 0,
    saldoContable: totalGeneral - totalTributos - totalErogaciones,
  };
};

const Spreadsheet = ({ item, dataProcedure: data, dataStateAccount }) => {
  const transformedData = transformData(item, data, dataStateAccount);
  return <MyDocClearanceForm data={transformedData} />;
};

const FormClone = (props) => {
  const { procedureId, reload, onClose } = props;

  return (
    <>
      <FormDefault
        tittle="Formulario para clonar items"
        fields={[
          {
            label: "Cantidad",
            name: "Nro",
            placeholder: "Cantidad",
            type: "text",
            typeInput: "input",
          },
        ]}
        initialValues={{
          Nro: "1",
        }}
        validationSchema={null}
        onSubmit={async (values) => {
          await requestAuth(
            "post",
            // `/procedureSheet/item/${item.id}/clone?place=down`,
            `/item/procedure/${procedureId}/number/${values.Nro}/clone`,
            values,
          )
            .then(() => {
              toast.success("Envio exitoso");
              reload();
              onClose();
            })
            .catch(() => {
              toast.error("Se produjo un error al enviar");
            });
        }}
        buttonName="Clonar"
      />
      <br />
    </>
  );
};

export default CloneItems;
